'use client';

import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getShouldShowSessionEndMessage } from '../../../actions/userSession.js';
import type { ShowDialogFn } from '../../../types.js';
import { endMessage } from '../dialogs/end-message.js';

export default function SessionEndMessage({ showDialog }: { showDialog: ShowDialogFn }) {
  const { data: shouldShow } = useQuery({
    queryKey: ['sessionEndMessage'],
    queryFn: getShouldShowSessionEndMessage,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (shouldShow) {
      void showDialog(endMessage);
    }
  }, [shouldShow, showDialog]);

  return null;
}
